module.exports = __webpack_public_path__ + "static/media/zunil.png";